import HighchartsVue from 'highcharts-vue';

export default {
  expose(Vue) {
    Vue.use(HighchartsVue, { tagName: 'charts' });
  },
};
